import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
// import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
const MainLayout = Loadable(lazy(() => import('layout/MainLayout')));
const DemoRequests = Loadable(lazy(() => import('views/admin-components/pages/DemoRequests')));

const loginType = localStorage.getItem('login_type');
const isAdminLogin = (loginType === 'admin')


const AdminRoute = {
    path: '/',
    element: isAdminLogin ? <MainLayout /> : <Navigate to={'/admin'} />,
    children: [

        // -------------ASSET CATEGORY---------------//
        { path: '/admin/demo-requests', element: isAdminLogin ? <DemoRequests /> : <Navigate to={'/admin'} /> },

        { path: '*', element: <Navigate to={<NotFound />} /> }
    ]
};


function NotFound() {
    return (
        <>
            <h4>Not Found</h4>
        </>
    )
}
export default AdminRoute;
